import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// mui components
import {
    Typography,
} from "@mui/material";


const AnalyticsPage = () => {
    const profile = useSelector(state => state.auth.profile);
    let api_token = (profile && profile.api_token) ? profile.api_token: "";
    let url = 'https://support.shippingchimp.com/deliveryperformance?token='+api_token;
    console.log(url);
    return (
        <>
            <div className="scmaincard">
                <div className="sccardhead">
                        <div  style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant="h5" gutterBottom component="div">
                                Analytics
                            </Typography>
                        </div>
                       
                </div>
                <div>
                    <Card sx={{ minWidth: '100%' }} className="sc--cardhead--details">
                        <CardContent>
                            <iframe
                                    width="100%"
                                    height="720"
                                    style={{ border:"none"}}
                                    loading="lazy"
                                    referrerpolicy="no-referrer"
                                    src={url}>
                            </iframe>
                        </CardContent>
                    </Card>
                </div>
                
            </div >
        </>
    );
}

export default AnalyticsPage;